export default __webpack_public_path__ + "static/media/standing-order-icon.842d96c6.svg";